<div class="container add-user">
    <div>
        <button class="closeHeader" (click)="closeDialog()">
            <img src="./assets/images/close cross.svg">
        </button>
    </div>
    <div class="row header">{{title}}</div>
    <form class="formDiv" #newUserClaim="ngForm" name="addEditUserForm">
        <div class="row subForm">
            <div class="col-lg-6 col-md-6 col-sm-12">
                <label>First Name</label>
                <input type="text" name="firstName" #firstName="ngModel" placeholder="Enter First name"
                    [(ngModel)]="admin.firstName" />
                <div *ngIf="(firstName.touched || newUserClaim.submitted) " class="alert-danger error">
                    <div class="text-danger" *ngIf="firstName.value == 0">
                        Missing item - First Name!
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
                <label>Last Name</label>
                <input type="text" name="lastName" #lastName="ngModel" placeholder="Enter Last name"
                    [(ngModel)]="admin.lastName" />
                <div *ngIf="(lastName.touched || newUserClaim.submitted) " class="alert-danger error">
                    <div class="text-danger" *ngIf="lastName.value == 0">
                        Missing item - Last Name!
                    </div>
                </div>
            </div>
        </div>
        <div class="row subForm">
            <div class="col-lg-6 col-md-6 col-sm-12">
                <label>Email ID</label>
                <input type="text" name="email" placeholder="Enter Mail ID" [(ngModel)]="admin.email" required
                    #email="ngModel" pattern="[a-zA-Z0-9.\-_]{1,}@[a-zA-Z.\-]{2,}[.]{1}[a-zA-Z]{2,}"
                    appEmailValidator [isAddScreen]="editable" [userID]="userId.value"
                    />
                <div *ngIf="email.invalid && (email.dirty || email.touched || newUserClaim.submitted)">
                    <div *ngIf="email.errors?.['required']" class="text-danger">Missing item - Email Address!</div>
                    <div *ngIf="email.errors?.['pattern']" class="text-danger"> Email address is invalid</div>
                    <div *ngIf="email.errors?.['emailExists']" class="text-danger"> Email Address already Exists!</div>
                </div>
            </div>
            <!-- </div> -->
            <div class="col-lg-6 col-md-6 col-sm-12">
                <label>User ID</label>
                <input type="text" name="userId" #userId="ngModel" placeholder="Enter User ID" appUserIDValidator
                    [(ngModel)]="admin.userID" [disabled]="!editable" />
                <div *ngIf="(userId.touched || newUserClaim.submitted) && (userId.value?.length == 0 || userId.invalid) " class="alert-danger error">
                    <div class="text-danger" *ngIf="userId.value?.length == 0">
                        Please enter New User ID.
                    </div>
                    <div class="text-danger" *ngIf="userId.errors?.['userIDExists']">
                        User ID already exists!
                    </div>
                </div>
            </div>
        </div>

        <div class="row subForm">
            <div [ngClass]="data.type == 'Add' ? 'col-lg-12 col-md-12 col-sm-12' : 'col-lg-6 col-md-6 col-sm-6'">
                <label>Access Level</label>
                <!--(change)="getAccessIds()" -->
                <select id="ddlAccessLevel" class="ddl" name="accessLevel" name="accessLevel"
                    [(ngModel)]="admin.accessLevelID" (change)="changeAccessLevel($event)"
                    [disabled]="loggedInUser.accessLevel == enumAccessLevel.DISTRICTUSER">
                    <option *ngFor="let accessLevel of accessLevelOptions" [value]="accessLevel.value">{{accessLevel.label}}</option>
                    <!-- <option value="0">Campus Official</option>
                    <option value="1">District Official</option>
                    <option value="2">Agent Official</option>
                    <option value="3">State Official</option>
                    <option value="5">Admin Official</option>
                    <option value="9">IT Official</option> -->
                </select>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 d-grid" *ngIf="data.type == 'Edit'">
                <label>Status</label>
                <div>
                    Inactive/Active
                    <mat-slide-toggle class="statusField" [checked]="admin.status" color="primary" name="status" [(ngModel)]="admin.status">
                    </mat-slide-toggle>
                </div>
            </div>
        </div>

        <div class="row subForm">
            <div class="col-lg-12 col-md-12 col-sm-12">
                <label>Access ID</label>

                <input type="text" placeholder="Search" [formControl]="accessId1" [matAutocomplete]="auto"
                    *ngIf="loggedInUser.accessLevel != enumAccessLevel.DISTRICTUSER" matTooltip="Minimum 3 characters are required to search the Access ID">
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="getOptionText"
                    (optionSelected)="selectedAccessId($event)">
                    <mat-option *ngFor="let accId of accessIds | async" [value]="accId">
                        <div class="my-1" *ngIf="admin.accessLevelID == enumAccessLevel.CAMPUSUSER">
                            <!-- <br /> -->
                            <small>{{ accId.name1 }}: </small>
                            <b>{{accId.iD1}}</b>
                            <br />
                            <small>{{ accId.name2 }}: </small>
                            <small class="fw-semibold text-secondary">{{accId.iD2}}</small>
                        </div>
                        <div *ngIf="admin.accessLevelID != enumAccessLevel.CAMPUSUSER">
                            <small>{{ accId.name1 }}: </small>
                            <b>{{accId.iD1}}</b>
                        </div>
                    </mat-option>
                </mat-autocomplete>

                <select id="ddlAccessId" name="accessId" class="ddl"
                    *ngIf="loggedInUser.accessLevel == enumAccessLevel.DISTRICTUSER" [(ngModel)]="admin.accessID">
                    <option value="">Select</option>
                    <option *ngFor="let accId of accessIdsDistrictUser" [value]="accId.iD1">{{accId.name1}}</option>

                </select>
            </div>
            <!-- <div class="col-lg-6 col-md-6 col-sm-6 d-grid">



            </div> -->
        </div>

        <div class="row subForm" *ngIf="data.type == 'Edit'">
            <div class="col-lg-12 col-md-12 col-sm-12">
                <a class="resendLetter" (click)="ResendWelcomeLetter()">Resend Welcome Letter</a>
            </div>
        </div>

        <div class="row subForm d-flex">
            <div class="col-lg-6 col-md-6 col-sm-12">
                <button type="button" class="cancelbtn" (click)="closeDialog()">Cancel</button>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
                <button type="submit" class="savebtn" (click)="saveUser(newUserClaim)">{{btnTitle}}</button>
            </div>
        </div>
    </form>
</div>

